<template>
    <div class="text-center font-Inter px-2.5">
        <h2 class="text-won-blue text-[30px] leading-[36px] font-bold">
            Get help from a pro!
        </h2>

        <p class="text-center text-[14px] leading-[17px] text-[#444C58] mt-4 tracking-[2%] font-medium">
            Looking for professional guidance? We can help!<br/><br/>

            90% of our clients land <span class="font-bold">interviews</span> within 3 months and 70% land <span class="font-bold">offers</span> in 6 months!
        </p>

        <div class="mt-11">
            <p class="italic !text-left font-semibold text-[13px] leading-[16px] tracking-[2%] text-won-dark-blue">
                "Wonsulting saved me time applying to jobs I didn’t know I should be applying to. I might say that it simplified the job search process and overall saved me time while I was interviewing. Besides that I would say that I really liked the service and found it useful. I don’t think that I would had applied that much on my own."
            </p>

            <div class="flex items-center gap-2.5 text-left mt-6 font-semibold w-fit mx-auto">
                <div class="rounded-full overflow-hidden w-10 h-10">
                    <img src="/img/alfredo-serano.webp" alt="Alfredo Serano" class="w-auto h-full object-cover">
                </div>
                
                <div>
                    <span class="block text-won-dark-blue text-[19px] leading-[23px]">Alfredo Serrano</span>
                    <span class="block mt-0.5 text-[#929497] text-[12px] leading-[14px]">Data Science Consultant at MS</span>
                </div>
            </div>
        </div>

        <div class="mt-20 mb-5 text-[16px] leading-[19px]">
            <button
                class="text-white bg-won-green rounded py-[9px] px-[77px]"
            >
                Explore Our Job Search Bundles
            </button>
        </div>
    </div>
</template>

<script setup>

</script>